<template>
  <div :class="wrapperClass">
    <template v-if="advertencia === true">
      <v-tooltip location="top">
        <template #activator="{ props }">
          <v-icon
            v-bind="props"
            :size="iconSize"
            color="warning"
            class="v-icon--clickable"
            @click.stop="showDialog = true"
          >mdi-alert</v-icon>
        </template>
        <div v-html="messages.CONDICION_EXPENDIO_ADVERTENCIA.replace('{0}', finalNombre || '—')" />
      </v-tooltip>
    </template>
    <template v-else-if="!finalNombre && advertencia !== true">
      <v-tooltip location="top">
        <template #activator="{ props }">
          <v-icon
            v-bind="props"
            :size="iconSize"
            color="warning"
            class="v-icon--clickable"
            @click.stop="showDialogNotFound = true"
            v-if="!isLoadingExpendios"
          >mdi-alert</v-icon>
          <!-- Mostrar un espacio vacío mientras carga o si no hay advertencia clasificada y no se encontró el nombre -->
          <span v-else></span>
        </template>
        <div v-html="messages.CONDICION_EXPENDIO_ADVERTENCIA.replace('{0}', '—')" />
      </v-tooltip>
    </template>
    <template v-else>
      <span>{{ finalNombre }}</span>
    </template>

    <!-- Dialogo advertencia clasificada -->
    <v-dialog v-model="showDialog" max-width="460">
      <v-card>
        <v-card-title class="text-subtitle-1">Advertencia</v-card-title>
        <v-card-text>
          <span v-html="messages.CONDICION_EXPENDIO_ADVERTENCIA.replace('{0}', finalNombre || '—')"></span>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="showDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo condicion no encontrada -->
    <v-dialog v-model="showDialogNotFound" max-width="460">
      <v-card>
        <v-card-title class="text-subtitle-1">Advertencia</v-card-title>
        <v-card-text>
          <span v-html="messages.CONDICION_EXPENDIO_ADVERTENCIA.replace('{0}', '—')"></span>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="showDialogNotFound = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  
</template>

<script>
import { mapGetters } from 'vuex';
import messages from '@/utils/enums/messages';
import { mapActions } from 'vuex';

export default {
  name: 'CondicionExpendio',
  props: {
    codigo: { type: String, default: null },
    nombre: { type: String, default: null },
    advertencia: { type: Boolean, default: null },
    center: { type: Boolean, default: false },
    alignRight: { type: Boolean, default: false },
    iconSize: { type: [String, Number], default: 16 },
  },
  data() {
    return {
      showDialog: false,
      showDialogNotFound: false,
      messages,
      isLoadingExpendios: false,
    };
  },
  computed: {
    ...mapGetters({ getNombrePorCodigo: 'taxonomy/getExpendioNombrePorCodigo' }),
    finalNombre() {
      return this.nombre || this.getNombrePorCodigo(this.codigo);
    },
    wrapperClass() {
      if (this.center) {
        return 'd-flex align-center justify-center w-100';
      } else if (this.alignRight) {
        return 'd-flex align-center justify-end w-100';
      }
      return '';
    },
  },
  async created() {
    // Intentar cargar los expendios si no están disponibles y no es una advertencia ya clasificada
    if (!this.getNombrePorCodigo('02')) {
      this.isLoadingExpendios = true;
      try {
        await this.getExpendiosSolicitudes();
      } finally {
        this.isLoadingExpendios = false;
      }
    }
  },
  methods: {
    ...mapActions({
      getExpendiosSolicitudes: 'taxonomy/getExpendiosSolicitudes',
    }),
  },
  watch: {
    // Observa cambios en el getter de expendios para re-evaluar si se necesita el diálogo
    getExpendioNombrePorCodigo: {
      handler() {
        if (!this.finalNombre && this.advertencia !== true && !this.isLoadingExpendios) {
          // Si después de una actualización, finalNombre sigue sin resolverse y no es una advertencia pre-clasificada,
          // y no estamos ya cargando, entonces podemos intentar cargar de nuevo o mostrar el diálogo.
          // Por ahora, solo nos aseguraremos de que el componente se re-renderice con los nuevos datos.
          // La lógica principal de carga ya está en 'created'.
        }
      },
      deep: true,
      immediate: false,
    },
  },
};
</script>

<style scoped>
.v-icon--clickable {
  cursor: pointer;
}
</style>


